import { GET_MARKETING_BANNERS, GET_SINGLE_MARKETING_BANNER, GET_HOME_PAGE_BANNERS } from "../../actions/type";

// activity intial state
const initialBanner = {
    marketingBanner: null,
    marketingbannerForEdit:null,
    isLoading: true,
    isEditLoading: true,
    homePageBanners: null
};

export const reducer = (state = initialBanner, action) => {
    switch (action.type) {
        case GET_MARKETING_BANNERS: {
            const banners = action.payload;
            return {
                ...state,
                marketingBanner: banners,
                isLoading: false,
            };
        }
        case GET_SINGLE_MARKETING_BANNER: {
            const marketingbannerForEdit = action.payload;
            return {
                ...state,
                marketingbannerForEdit,
                isEditLoading: false,
            };
        }
        case GET_HOME_PAGE_BANNERS: {
            const banners = action.payload;
            return {
                ...state,
                homePageBanners: banners,
                isLoading: false,
            };
        }
        default:
            return state;
    }
};